import * as $ from 'jquery';
import Control from 'ol/control/Control';
import {updateMapLayers} from '../mapLayers'

export default class MapType extends Control {
    static get controlName() {
        return 'map-type';
    }

    constructor(opt_options) {
        opt_options = opt_options || {};
        let defaultType = opt_options.mapType || 'map';
        let buttonMap = $('<button class="ol-map-type-map selected">地图</button>');
        let buttonSatellite = $('<button class="ol-map-type-satellite">卫星图</button>');
        let mapType = $(`<div class="ol-map-type ol-unselectable ol-control"></div>`)
            .append(buttonMap, buttonSatellite);
        super(Object.assign({element: mapType[0]}, opt_options));
        this.set("name", MapType.controlName);

        let onClick = mapType => {
            this.setMapType(mapType);
            switch (mapType) {
                case 'map':
                    buttonMap.addClass('selected');
                    buttonSatellite.removeClass('selected');
                    break;
                case 'satellite':
                    buttonMap.removeClass('selected');
                    buttonSatellite.addClass('selected');
                    break;
            }
        };

        buttonMap.on('click', () => onClick('map'));
        buttonSatellite.on('click', () => onClick('satellite'));
        setTimeout(() => onClick(defaultType));
    }

    setMapType(mapType) {
        this.set("mapType", mapType);
        updateMapLayers(this.getMap());
        this.getMap().dispatchEvent({type: "mapTypeChanged", mapType: mapType});
    }
}
